module.exports = __webpack_public_path__ + "static/media/Frame 1171276368.4abf6c47.svg";